import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PGWPaymentAggregatorContainerModel} from "../../../../../models/aggregates/pgw/pgw-payment-aggregator.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PGWPaymentAggregatorQueryCriteriaClass,
  PGWPaymentAggregatorCriteriaModelQuery,
} from "../../criteria/pgw/pgw-payment-aggregator.model";

@Injectable({
  providedIn: "root",
})
export class PGWPaymentAggregatorService extends BaseApiTemplateService<PGWPaymentAggregatorContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "aggregators";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "aggregators";
    this.httpClient = http;
  }

  getPGWPaymentAggregatorByCriteria(
    visa: ApiVisa,
    criteria?: PGWPaymentAggregatorQueryCriteriaClass
  ): Observable<PagingResponseModel<PGWPaymentAggregatorContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildPGWPaymentAggregatorCriteria = new PGWPaymentAggregatorCriteriaModelQuery(criteria);
    console.log("query", buildPGWPaymentAggregatorCriteria.query);
    return this.httpClient.get<PagingResponseModel<PGWPaymentAggregatorContainerModel>>(
      this.apiUrl + "/query?" + buildPGWPaymentAggregatorCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
